import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				overflow: "hidden"
			},
			rootTabs: {
				"& div.MuiTabs-scroller": {
					"& .MuiTabs-flexContainer": {
						justifyContent: "space-around"
					}
				}
			},
			rootAppBar: {
				background: theme.palette.common.white,
				boxShadow: "none !important",
				borderBottom: `1px solid ${theme.palette.grey[800]}`
			},
			rootTab: {
				color: theme.palette.grey[700],
				minWidth: 120,
				fontSize: 16,
				textTransform: "inherit",
				fontWeight: 400
			},
			selected: {
				color: `${theme.palette.primary.contrastText} !important`,
				fontWeight: 500
			}
		}),
	{
		name: "HorizontalMenu",
		index: 1
	}
);

export default useStyles;
